import { AxiosInstance } from 'axios';
import { BaseRequest } from '@trukt/types/BaseRequest';
import { JobFinance } from '@trukt/types/JobFinance';

export type JobFinanceUpdateRequestBodyCommodity = {
  guid: string;
  payment: string;
};

export type JobFinanceUpdateRequestBody = {
  payment?: string;
  commodities?: JobFinanceUpdateRequestBodyCommodity[];
};
export type JobFinanceUpdateRequest = BaseRequest<
  void,
  JobFinanceUpdateRequestBody,
  { jobGuid: string }
>;
export type JobFinanceUpdateResponse = void;

export type JobFinanceGetRequest = BaseRequest<void, void, { jobGuid: string }>;
export type JobFinanceGetResponse = JobFinance;

export class JobFinanceService {
  instance: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  get({ routeParams }: JobFinanceGetRequest) {
    return this.instance.get<JobFinanceGetResponse>(`/jobs/${routeParams.jobGuid}/finances`);
  }

  update({ routeParams, body }: JobFinanceUpdateRequest) {
    return this.instance.put(`/jobs/${routeParams.jobGuid}/finances`, body);
  }
}
